import React from 'react';

import { isServer } from '@atlassian/eoc-common';
import { eocUserResource } from '@atlassian/eoc-resources';
import { routingRulesResource } from '@atlassian/eoc-routing-rules/resources';
import { useResource } from '@atlassian/eoc-rrr-helpers';
import { getTimezonesResource } from '@atlassian/eoc-schedule-common/resources';
import {
	getScheduleRightsResource,
	getSchedulesResource,
	getScheduleTimeTemplatesResource,
	getUiPreferencesResource,
} from '@atlassian/eoc-schedule/resources';

import { type PageProps } from '../common/types';
import { getTeamResource } from '../services/resources';

import { Error } from './error';
import { Loading } from './loading';
import { OnCallPage } from './page';

const OnCall = ({ onReady, onRoutingRuleModalOpen }: PageProps) => {
	const { loading: getTeamLoading, error: getTeamError } = useResource(getTeamResource);
	const { loading: getScheduleRightsLoading, error: getScheduleRightsError } =
		useResource(getScheduleRightsResource);
	const { loading: getSchedulesLoading, error: getSchedulesError } =
		useResource(getSchedulesResource);
	const { loading: getUiPreferencesLoading, error: getUiPreferencesError } =
		useResource(getUiPreferencesResource);
	const { loading: getScheduleTimeTemplatesLoading, error: getScheduleTimeTemplatesError } =
		useResource(getScheduleTimeTemplatesResource);
	const { loading: eocUserLoading, error: eocUserError } = useResource(eocUserResource);
	const { loading: routingRulesLoading, error: routingRulesError } =
		useResource(routingRulesResource);
	const { loading: getTimezonesLoading, error: getTimezonesError } =
		useResource(getTimezonesResource);

	const isError =
		getTeamError ||
		getScheduleRightsError ||
		getSchedulesError ||
		getUiPreferencesError ||
		getScheduleTimeTemplatesError ||
		eocUserError ||
		routingRulesError ||
		getTimezonesError;
	const isLoading =
		getTeamLoading ||
		getScheduleRightsLoading ||
		getSchedulesLoading ||
		getUiPreferencesLoading ||
		getScheduleTimeTemplatesLoading ||
		eocUserLoading ||
		routingRulesLoading ||
		getTimezonesLoading;

	if (isError) {
		return <Error />;
	}

	if (isLoading || isServer()) {
		return <Loading />;
	}

	return <OnCallPage onReady={onReady} onRoutingRuleModalOpen={onRoutingRuleModalOpen} />;
};

export { OnCall };
